/**
 * Raised when the prompt tiles stream completes successfully but contains no prompt tiles: the
 * backend's `FINAL_RESPONSE` reports `tiles_sent: 0` and no `ERROR` message was received.
 *
 * The backend can legitimately return an empty stream (for example when the user has no recent
 * worked-on activity to personalise from; view-only activity doesn't count), so this is an expected
 * outcome rather than a service failure. It is
 * still surfaced as the hook's `error` so hosts keep falling back to their static prompts, but
 * consumers should use `isPromptSuggestionsEmptyError` to avoid treating it as a failure.
 */
export class PromptSuggestionsEmptyError extends Error {
	static readonly errorName = 'PromptSuggestionsEmptyError';

	/**
	 * Types of unexpected stream messages that were received but skipped (anything other than
	 * prompt tiles, `ERROR` or `FINAL_RESPONSE`). Useful for spotting new backend message types.
	 */
	readonly skippedMessageTypes: string[];

	constructor({ skippedMessageTypes = [] }: { skippedMessageTypes?: string[] } = {}) {
		super('No prompt suggestions returned');
		this.name = PromptSuggestionsEmptyError.errorName;
		this.skippedMessageTypes = skippedMessageTypes;
	}
}
